export default {
    ai: 'AI-assistent',
    export: 'Exportera',
    blue: 'Blå',
    yellow: 'Gul',
    pink: 'Pink',
    orange: 'Orange',
    all: 'Allt',
    generateApaCopy: 'Skapa APA-citat',
    apaCopied: '¡Citat kopieras till Urklipp!',
    imReading: `I'm reading`,
    in: 'in',
    by: 'By',
    article: 'Article',
    prevArticle: 'Previous Article',
    nextArticle: 'Next Article',
    imHere: `Yes, I'm here`,
    sessionExpiredAlert: 'Your reading session is about to end.',
    sessionExpiredAreYouThere: 'Are you there?',
    sessionExpired: 'Your reading session has expired due to inactivity.',
    returnToLibrary: 'Return to Library',
    sessionValidExpired: 'Sessionen har löpt ut',
    sessionValidExpiredPleaseLoginAgain: 'Logga in igen',
    tableOfContents: 'Table of Contents',
    tableOfContentsNotAvailable: 'No table of contents available.',
    pages: 'pages',
    page: 'page',
    thumbnails: 'Thumbnails',
    settings: 'Settings',
    bookmarks: 'Bookmarks',
    highlights: 'HighLights',
    highlight: 'HighLight',
    notes: 'Anteckningar',
    note: 'Note',
    notebook: 'Notebook',
    search: 'Search',
    theme: 'Theme',
    pageLayout: 'Page Layout',
    typography: 'Typografi',
    fontDefault: 'Standard',
    lineSpacing: 'Radavstånd',
    lineSpacingCompact: 'Kompakt',
    lineSpacingNormal: 'Normal',
    lineSpacingWide: 'Bred',
    margins: 'Marginaler',
    marginsMinimum: 'Minimum',
    marginsNormal: 'Normal',
    marginsMaximum: 'Maximum',
    continuous: 'Continuous',
    readingModes: 'Läslägen',
    zoomTitle: 'Textstorlek',
    zoomTitlePdf: 'Zooma',
    zoomTimes: 'Times',
    onePage: 'Horisontell',
    onePageScroll: 'Vertikal',
    twoPages: 'Dubbel',
    twoPagesScroll: 'Två sidor rullar',
    citation: {
        buttons: {
            Iso690: 'Generate ISO690 citation',
            APA: 'Generate APA citation',
            Vancouver: 'Generate Vancouver citation',
            IEEE: 'Generate IEEE citation',
            MLA: 'Generate MLA citation',
            ABNT: 'Generate ABNT citation',
        },
        menu: {
            title: 'Generate citation',
            Iso690: 'ISO 690',
            APA: 'APA',
            Vancouver: 'Vancouver',
            IEEE: 'IEEE',
            MLA: 'MLA',
            ABNT: 'ABNT',
        },
        messages: {
            copied: 'Citation copied to clipboard!',
            availableIn: 'Available in',
            online: 'Internet',
            generated: 'cited',
            websiteName: 'publica.la',
            and: 'och',
        },
    },
    'ai-integrations': {
        buttons: {
            explain: 'Explain concept',
            expand: 'Expand information',
            summarize: 'Summarize idea',
        },
        menu: {
            title: 'AI Assistant (Beta)',
        },
        messages: {
            copied: '¡Response copied to clipboard!',
            addedToResponse: '«Response copied from publica.la Reader»',
        },
        thanksFeedback: '¡Thanks for your feedback!',
        errorFeedback: 'Sending feedback failed. ¿Can you retry?',
    },
    onlyCopy: 'Copy plain text',
    translate: 'Translate',
    copy: 'copy',
    changeColor: 'Change color',
    socialShare: 'Share',
    zoom: {
        auto: 'Auto',
        'page-fit': 'Page Fit',
        'page-width': 'Page Width',
    },
    filter: 'Filter',
    noFilterHighlights: 'Select a filter to see your highlights',
    noFilterHighlightsColor: 'There is nothing highlighted in this color',
    noHighlights: 'You have not made highlights yet',
    noFilterNotes: 'Select a color to see your notes',
    noFilterNotesColor: 'There are no notes of this color',
    noNotes: 'You have not written notes yet',
    noFilterHighlightsAndNotes: 'Select a color to see your highlights and notes',
    noFilterHighlightsAndNotesColor: 'There is no notes or highlights of this color',
    noHighlightsAndNotes: 'You have not created any highlights or notes yet',
    plainCopied: 'Text copy to clipboard!',
    onboarding: {
        next: 'Next',
        finish: 'Finish',
        skip: 'Skip tutorial',
        previous: 'Previous',
        reader: {
            welcome: {
                title: 'Välkommen till ditt läsutrymme',
                paragraph: 'Upptäck hur du kan få ut det mesta av dina böcker med de tillgängliga verktygen i läsaren.',
                extraParagraph: 'Njut av ditt nya läsutrymme!',
            },
            highlights: {
                title: 'Förbättra din läsupplevelse',
                paragraph:
                    'Markera text, skapa anteckningar, generera citat, översätt och lyssna på innehållet. Ta din läsupplevelse till nästa nivå i alla format.',
            },
            resumes: {
                title: 'Hantera ditt innehåll',
                paragraph:
                    'Öka din produktivitet. Hantera dina anteckningar, markeringar, citat och sammanfattningar på ditt sätt. Dela dina idéer snabbt och enkelt.',
            },
            appPromote: {
                title: 'Läs eller lyssna var som helst',
                paragraph:
                    'Få åtkomst till ditt innehåll när och hur du vill, utan internetanslutning, på den enhet du föredrar.',
                extraParagraph: 'Ladda ner vår app!',
            },
        },
        audiobook: {
            welcome: {
                title: 'Welcome',
                subTitle: 'How to use the reproductor?',
                paragraph: 'Learn how use the functions and make the most of your listening.',
            },
            reproduction: {
                title: 'Playback control',
                paragraph: 'Advance, delay or pause audiobook playback.',
            },
            narratorSpeed: {
                title: 'Increase and reduce the speed of narration',
                paragraph: 'You can choose the speed with which the audiobook is listened to, as you prefer.',
            },
            chapters: {
                title: 'Advance and return in chapters',
                paragraph: 'Move between chapters in an agile and fast way.',
            },
        },
    },
    author: 'Author',
    publisher: 'Publisher',
    narrator: 'Narrator',
    narratedBy: 'Narrated by',
    aboutThisPublication: 'About this publication',
    listening: {
        label: 'Listen',
        voice: 'Voice',
    },
    searchResultEmpty: 'Inga resultat hittades',
    searchLengthError: 'Sökningen måste vara mellan 4 och 128 tecken',
    keepTyping: 'Fortsätt skriva…',
    loading: 'Laddar...',
    searchLoading: 'Searching...',
    searchTitle: 'Sök',
    lastSearch: 'Förslag',
    searchExplanation: 'Find words in an agile way on all publication',
    networkIsOffline: 'No internet connection available. Some features are unavailable.',
    about: 'About',
    chapters: 'Chapters',
    duration: 'Duration',
    narratorSpeed: 'Narrator speed',
    slowNarration: 'Slow storytelling',
    normalNarration: 'Normal storytelling',
    fastNarration: 'Fast storytelling',
    shareIssue: 'Share publication',
    shareArticle: 'Share Article',
    copyUrl: 'Copy URL',
    shareCurrentPage: 'Share current page',
    shareCurrentPosition: 'Share current position',
    copyUrlToClipboard: 'URL copied to clipboard',
    tooltips: {
        zoomOut: 'Zoom out',
        zoomIn: 'Zoom in',
        config: 'Configuration',
        tableOfContents: 'Table of contents',
        search: 'Search',
        highlights: 'Highlights',
        notebook: 'Notebook',
        listen: 'Listen',
        bookmarks: 'Bookmarks',
        openThumbnails: 'Thumbnails',
        closeThumbnails: 'Exit thumbnails',
        share: 'Share',
        prev: 'Prev',
        next: 'Next',
        close: 'Close',
        back: 'Back',
        download: 'Offline-åtkomst',
        themeTitle: 'Utseende',
        themeLight: 'Light',
        themeDark: 'Dark',
        themeCream: 'Cream',
        themeSepia: 'Sepia',
        themeCyan: 'Cyan',
        themeHighContrast: 'Hög kontrast',
        themeHighContrastDark: 'Hög kontrast mörk',
        clear: 'Clear',
        citation: 'Citation',
        dictionary: 'Dictionary',
        aiIntegrations: 'AI Assistant (Beta)',
        aiAction:
            'This tool uses AI, so there may be inaccurate information. More improvements coming soon! What do you think? Use the icons below to share your thoughts.',
        translate: 'Translate',
        about: 'About',
        rewind: 'Rewind',
        forward: 'Forward',
        createNote: 'Create a note',
        createHighlight: 'Highlight',
        deleteHighlight: 'Delete highlight',
        help: 'Help',
        lists: 'Lists',
        copy: 'Copy',
        goodResponse: 'Good response',
        badResponse: 'Bad response',
        moreActions: 'Fler åtgärder',
        moreOptions: 'Fler alternativ',
        play: 'Spela',
        pause: 'Pausa',
        seekPosition: 'Spårposition',
        zoomReset: 'Återställ zoom',
        smartZoom: 'Smart Zoom',
        themeSystem: 'Systemtema',
        searchInBook: 'Sök i boken',
        pageSlider: 'Sidnavigering',
    },
    save: 'Save',
    delete: 'Delete',
    cancel: 'Cancel',
    confirmDelete: {
        title: 'Ta bort anteckning',
        message: 'Är du säker på att du vill ta bort denna anteckning? Denna åtgärd kan inte ångras.',
    },
    confirmResetSettings: {
        title: 'Återställ inställningar',
        message: 'Alla visuella inställningar återställs till standardvärdena.',
    },
    resetSettings: 'Återställ inställningar',
    writeNote: 'Write a note',
    speakNow: 'Speak now',
    listeningSpeech: 'Listening',
    share: {
        copyShare: 'Kopiera och dela',
        qrCodeTitle: 'QR-kod',
        scanQr: 'Skanna QR-koden med din WeChat-app',
        copyLink: 'Kopiera publikationens URL',
        copy: 'Kopiera',
        copied: 'kopierat!',
        openWechat: 'Öppna WeChat-appen',
        openingWechat: 'Öppnar WeChat-appen...',
        sendCopiedUrl: 'Skicka kopierad URL till en kontakt',
    },
    buyNow: 'Buy now',
    buyNowText: 'Get the full version.',
    preview: 'Sample',
    changeLayoutNotAllowed: 'The content does not allow to change the page layout',
    nativeTtsLang: {
        'en-US': 'English (United States)',
        'en-GB': 'English (United Kingdom)',
        'en-scotland': 'English (Scotland)',
        'en-AU': 'English (Australia)',
        'en-IE': 'English (Ireland)',
        'en-IN': 'English (India)',
        'en-ZA': 'English (South Africa)',
        en: 'English',
        'es-AR': 'Spanish (Argentina)',
        'es-ES': 'Spanish (Spain)',
        'es-MX': 'Spanish (Mexico)',
        'es-US': 'Spanish (United States)',
        es: 'Spanish',
        'it-IT': 'Italian (Italy)',
        it: 'Italian',
        'pt-PT': 'Portuguese (Portugal)',
        'pt-BR': 'Portuguese (Brazil)',
        pt: 'Portuguese',
        'fr-CA': 'French (Canada)',
        'fr-FR': 'French (France)',
        fr: 'French',
        pl: 'Polish',
        'pl-PL': 'Polish (Poland)',
    },
    promoteApp: {
        downloadAppStore: 'Download on the App Store',
        downloadPlayStore: 'Get it on Google Play',
        title_read: 'Take your readings wherever you go with',
        title_audio: 'Take your audiobooks wherever you go with',
        text: 'Få tillgång till ditt innehåll när och hur du vill, utan att behöva en internetanslutning, på den enhet du föredrar. Ladda ner vår app!',
        title_first_part: 'Med',
        title_second_part: 'ta dina läsningar vart du än går',
    },
    dictionary: 'Dictionary',
    selectionTooLongLine1: 'The selection has too many words.',
    selectionTooLongLine2: 'Try selecting up to 5 words.',
    dictionaryValidation: {
        message: 'You selected {count} words.\nPlease try selecting up to {max} words.',
    },
    translateValidation: {
        message: 'You selected {count} characters.\nPlease try selecting up to {max} characters.',
    },
    ttsValidation: {
        message: 'You selected {count} characters.\nPlease try selecting up to {max} characters.',
    },
    aiValidation: {
        message: 'You selected {count} characters.\nPlease select between {min} and {max} characters.',
    },
    alreadyPurchased: 'Already purchased?',
    logIn: 'Log in',
    addToAList: 'Add to a list',
    lists: 'Lists',
    nextSection: 'Next section',
    prevSection: 'Previous section',
    new: 'New',
    skipLinks: {
        navLabel: 'Snabblänkar',
        showControls: 'Visa kontroller',
    },
    accessibility: {
        textSelected: '{count} tecken markerade. Markeringsverktyg tillgängliga.',
        pageChanged: 'Sida {current} av {total}',
    },
};
